var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1675 17.5H0.539375V5.81625H4.1675V17.5ZM2.35125 4.2225C1.19125 4.2225 0.25 3.26125 0.25 2.10125C0.25 1.54396 0.471381 1.0095 0.865442 0.615442C1.2595 0.221381 1.79396 0 2.35125 0C2.90854 0 3.443 0.221381 3.83706 0.615442C4.23112 1.0095 4.4525 1.54396 4.4525 2.10125C4.4525 3.26125 3.51125 4.2225 2.35125 4.2225ZM17.7462 17.5H14.1262V11.8125C14.1262 10.4569 14.0987 8.71875 12.24 8.71875C10.3537 8.71875 10.0644 10.1912 10.0644 11.715V17.5H6.44V5.81625H9.91937V7.41H9.97C10.4544 6.49187 11.6375 5.52312 13.4025 5.52312C17.0744 5.52312 17.7494 7.94125 17.7494 11.0819V17.5H17.7462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.af55caaf1d1255d539ffe127b34e5824.svg";
export { ForwardRef as ReactComponent };